import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { MatSelectChange } from "@angular/material/select";
import { Section } from "@cotecna/dynamic-view-engine";
import { ToggleSection } from "src/app/inspection/new-inspection/models/toggle-section";
import { ScopeOfWorkListConfig } from "src/app/inspection/permissions-setter/permissions-interface";
import { ScreenInfo } from "src/app/settings/models/screen-info";

@Component({
  selector: "im-sow-sections",
  templateUrl: "./sow-sections.component.html",
  styleUrls: ["./sow-sections.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SowSectionsComponent {
  @Input()
  creationMode: boolean;

  @Input()
  defaultFormId: string;

  @Input()
  config: ScopeOfWorkListConfig;

  @Input()
  toggleSections: ToggleSection[] = [];

  @Input()
  sowScreens: ScreenInfo[] = [];

  @Output()
  toggleChanged: EventEmitter<ToggleSection> =
    new EventEmitter<ToggleSection>();

  @Output()
  sowFormChanged: EventEmitter<string> = new EventEmitter<string>();

  isLoading: boolean = false;
  isLoadingSections: boolean = false;

  constructor() {}

  onToggleChanged(toggle: ToggleSection) {
    this.toggleChanged.next({ ...toggle });
  }

  async onSowFormChanged(selectChange: MatSelectChange) {
    this.sowFormChanged.next(selectChange.value);
  }
}
